import React, {useEffect, useState} from 'react';
import Header from '../../../../components/header';
import Bottom from '../../../../components/contact';
import Reserve from '../../../../components/reserve';
import BasicLayout from '../../../../layout/basicLayout';
import {SCHOOL} from '../../../../contant';
import Bread from '../../../../components/bread';

const CooperateDetail = (props) => {
    const [school,setSchool] = useState({})
    useEffect(()=>{
        const {query} = props?.location
        const newTitle = query?.title ? query?.title : localStorage.getItem('schoolTitle')
        localStorage.setItem('schoolTitle', newTitle)
        const school = SCHOOL.find(ele=>ele.title === newTitle)
        setSchool(school)

        setTimeout(() => {
            const anchorElement = document.getElementById('schoolDetail')
            if (anchorElement) {
                anchorElement.style.width = '710px';
            }
        }, 1)

        return () => {
            localStorage.removeItem('schoolTitle');
        }
    }, [])

    return <BasicLayout>
        <Header fixed/>
        <div >
            <div style={{height:'100px'}}/>
            <Bread breads = {[{name:'首页',href: '#/home'},{name:'商业合作',href:'#/cooperate'},{name:'案例详情'}]}/>
            {school.content}
        </div>
        <Bottom/>
        <Reserve/>
    </BasicLayout>;
};
export default CooperateDetail;
